import "./styles.scss";

import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import DetailsCard from "components/DetailsCard";

import task_status_data from "libs/task_status_data.json";

const mainClass = "dashboard-task-summary";

const targetStatuses = [1, 2, 3, 5];

const TaskSummary = ({ title, data }) => {
  const { t } = useTranslation();

  const tasks = data?.filter((task) => targetStatuses.includes(task.status));
  const validStatuses = task_status_data.filter((status) =>
    targetStatuses.includes(status.value),
  );
  const tasksByStatus = (() => {
    const counts = validStatuses.reduce((acc, s) => {
      acc[s.value] = 0;
      return acc;
    }, {});

    if (!Array.isArray(tasks)) return counts;

    for (const task of tasks) {
      const status = task?.status;
      if (validStatuses.map((status) => status.value).includes(status))
        counts[status] += 1;
    }

    return counts;
  })();

  const maxTaskCount = Math.max(...Object.values(tasksByStatus));

  return (
    <DetailsCard title={title || t("Summary of all active tasks")}>
      <div className={mainClass}>
        {Object.entries(tasksByStatus).map(([k, v]) => {
          const status = validStatuses.find(
            (status) => status.value === Number(k),
          );
          const key = status?.key;
          const label = status?.label;
          const percentage = ((v / maxTaskCount) * 100).toFixed(0);
          const statusName = task_status_data.find(
            (s) => s.value === Number(k),
          )?.key;

          return (
            <div
              key={key}
              className={`${mainClass}__item  ${mainClass}__item--${key}`}
            >
              <div className={`${mainClass}__item-chart`}>
                <div
                  className={`${mainClass}__item-chart-bar`}
                  style={{ height: `${percentage}%` }}
                />
              </div>
              <div className={`${mainClass}__item-label`}>
                {t(label)}
                <span>{v}</span>
              </div>
              {v > 0 && (
                <NavLink
                  to={`/tasks?status=${statusName}`}
                  className={`${mainClass}__item-link`}
                />
              )}
            </div>
          );
        })}
      </div>
    </DetailsCard>
  );
};

export default TaskSummary;
